import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { HeaderService } from '@telecom/shared/services/header-service/header-service';
import type { HeaderServiceProxy } from '@telecom/shared/services/header-service/header-service-proxy';

@injectable()
export class HeaderServiceProxyImpl implements HeaderServiceProxy {
    constructor(
        @inject(HeaderService)
        public headerService: HeaderService,
    ) {
        // this._modifyLocales();
        this.headerService.visibleProducts = false;
        this.headerService.deferred.promise
            .then(() => {
                // 只有企业用户才展示九宫格
                this.headerService.visibleProducts = !!this.headerService.account?._info.company_id ;
            });
    }

    // private _modifyLocales(): void {
    //     const locales = this.headerService.locales
    //         .filter(locale => locale.key !== 'jp' && locale.key !== 'tw');
    //     this.headerService.locales = locales;
    // }
}
